import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const dateStyles = (fieldVariant: FieldVariant) => {
  const styles = {
    [FieldVariant.dataRow]: {
      root: {},
    },
    [FieldVariant.form]: {
      root: {
        '& .material-icons-outlined': {
          pointerEvents: 'none',
        },
      },
    },
  };

  return styles[fieldVariant];
};
